export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/performance/worker_wage',
      method: 'GET'
    },
    {
      path: '/performance/wage_level',
      method: 'GET'
    },
    {
      path: '/performance/wage_job_title',
      method: 'GET'
    },
    {
      path: '/performance/worker',
      method: 'GET'
    }]
  },
  batch: {
    funKey: 'batch',
    name: '复制上月',
    apis: [{
      path: '/performance/worker_wage/batch',
      method: 'POST'
    },
    {
      path: '/performance/worker_wage/batch',
      method: 'PUT'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/performance/worker_wage/{id}',
      method: 'PUT'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/performance/worker_wage/{id}',
      method: 'DELETE'
    }]
  }
}